import { render, staticRenderFns } from "./CardOrderDetail.vue?vue&type=template&id=7b2f21ce&scoped=true"
import script from "./CardOrderDetail.vue?vue&type=script&lang=js"
export * from "./CardOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2f21ce",
  null
  
)

export default component.exports